import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "../homepage/Home";
import PropertyListing from "../pages/PropertyListing";
import PropertyDetails from "../pages/PropertyDetails";
import BlogDetails from "../pages/BlogDetails";
import AboutUs from "../pages/AboutUs";
import ContactUs from "../pages/ContactUs";
import TermAndCondition from "../pages/TermAndCondition";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import AllCategory from "../pages/AllCategory"
import AllLocations from "../pages/AllLocations"
import BlogInner from "../pages/BlogInner";
import ScrollToTop from "./ScrollToTop";

function Routes() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <ScrollToTop><Home /></ScrollToTop>,
    },
    {
      path: "/property-listing",
      element: <ScrollToTop><PropertyListing /></ScrollToTop>,
    },
    {
      path: "/property-details/:productSlug",
      element: <ScrollToTop><PropertyDetails /></ScrollToTop>,
    },
    {
      path: "/blogs",
      element: <ScrollToTop> <BlogDetails /></ScrollToTop>
    },
    {
      path: "/about-us",
      element: <ScrollToTop><AboutUs /></ScrollToTop>
    },
    {
      path: "/contact-us",
      element: <ScrollToTop><ContactUs /></ScrollToTop>
    },
    {
      path: "/term-condition",
      element: <ScrollToTop><TermAndCondition /></ScrollToTop>
    },
    {
      path: "/privacy-policy",
      element: <ScrollToTop><PrivacyPolicy /></ScrollToTop>
    },
    {
      path: "/categories",
      element: <ScrollToTop> <AllCategory /></ScrollToTop>
    },
    {
      path: "/locations",
      element: <ScrollToTop><AllLocations /></ScrollToTop>
    },
    {
      path: "/blog-detail/:blogSlug",
      element: <ScrollToTop> <BlogInner /></ScrollToTop>
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default Routes;
